const checkEmail = (rule, value, callback) => {
  const mailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (mailReg.test(value)) {
    callback();
  } else {
    callback(new Error('正しいメールアドレスを入力ください。'));
  }
};

const checkPassword = (rule, value, callback) => {
  const letterReg = /[a-zA-Z]/;
  const numberReg = /[0-9]/;

  if (letterReg.test(value) && numberReg.test(value) && value.length > 5) {
    callback();
  } else {
    callback(new Error('パスワードは英字と数字をどちらも含む6文字以上の半角英数記号でご設定ください。'));
  }
};

const checkUserName = (rule, value, callback) => {
  const letterReg = /[a-zA-Z]/;
  const numberReg = /[0-9]/;

  if (letterReg.test(value) && numberReg.test(value) && value.length > 5) {
    callback();
  } else {
    callback(new Error('ログインIDは半角英数字を入力してください。'));
  }
};

const shouldShowDetailList = (status) => ['1', '2', '3'].indexOf(status) > -1;

/**
 * 郵便番号
 * @param {*} s
 */
export function isZipCode(s) {
  return /^[0-9]{3}[0-9]{4}$/.test(s);
}

/**
 * kana
 * @param {*} s
 */
export function isKana(s) {
  return /^[\u30A0-\u30FF]+$/.test(s);
}

/**
 * 日本手机号码
 * @param {*} s
 */
export function isMobile(s) {
  // return /^1[0-9]{10}$/.test(s)
  return /0[789]0-?[0-9]{4}-?[0-9]{4}$/.test(s);
}

/**
 * 日本固定电话
 * @param {*} s
 */
export function isFixedPhone(s) {
  return /^0[0-9]{9}$/.test(s);
}

/**
 * 日本传真
 * @param {*} s
 */
export function isFax(s) {
  return /^0[0-9]{9}$/.test(s);
}

export default {
  checkEmail,
  checkPassword,
  checkUserName,
  shouldShowDetailList,
};

/**
 * ファイルチェック
 * @param {File} file - Fileオブジェクト
 * @param {Object} options - チェック条件
 * @param {string[]} options.allowedTypes - 許可されるMIME型例：['application/pdf'] or ['image/jpeg', 'image/png']
 * @param {number} options.maxSizeMB - 最大サイズ（MB単位）
 * @param {string} [options.msg] - 追加パラメータ（省略可、デフォルト空文字）
 * @returns {string|null} - エラーメッセージ（OKならnull）
 */
export function validateFile(file, { allowedTypes = [], maxSizeMB = 10, msg = ''  } = {}) {
  // ファイル選択チェック
  if (!file) {
    return msg + 'ファイルを選択してください。';
  }

  // ファイル形式チェック
  if (allowedTypes != null) {
    if (allowedTypes.length > 0 && !allowedTypes.includes(file.type)) {
      const readableTypes = allowedTypes
        .map(t => {
          if (t === 'application/pdf') return 'PDF';
          if (t === 'image/jpeg') return 'JPG';
          if (t === 'image/png') return 'PNG';
          if (t === 'image/webp') return 'WEBP';
          return t.split('/')[1].toUpperCase(); 
        })
        .join('/');
      return `${readableTypes}形式のファイルを選択してください。`;
    }
  }

  // ファイルサイズチェック
  if (file.size > maxSizeMB * 1024 * 1024) {
    return `ファイルサイズは最大${maxSizeMB}MBまでです。`;
  }

  return null;
}

